import React, { useMemo } from 'react'
import {
  Button,
  Dialog,
  DialogContent,
  Stack
} from "@mui/material"


import {
  WarningAmber as WarningAmberIcon,
  BadgeOutlined as BadgeOutlinedIcon,
  PersonOutlineOutlined as PersonOutlineOutlinedIcon
} from '@mui/icons-material'

import { defaultFunction, getFullName } from "../../utilities/utilities"

import { useTranslation } from 'react-i18next'
import { DEFAULT_BLACK_LIST_USER } from "../../../variables"
import { connect } from 'react-redux'

import './BlackListDialog.sass'

function BlackListDialog(props) {
  const {
    open = false,
    onClose = defaultFunction,
    user = DEFAULT_BLACK_LIST_USER,
    rejectReason = {},
    custom_visit_identification_label = '',
  } = props

  const { t } = useTranslation()
  const identificationLabel = custom_visit_identification_label || t('Identification')

  const fullName = useMemo(() => getFullName(user), [user])
  const color = rejectReason.color || '#CB7B01'

  return (
    <Dialog
      className='blacklist-dialog'
      open={open}
      onClose={onClose}
      maxWidth="sm">
      <DialogContent>
        <Stack gap={3}>
          <Stack gap={1} alignItems="center" className='blacklist-header' style={{ color }}>
            <WarningAmberIcon color={color} />
            <h2>
              {rejectReason.reason}
            </h2>
          </Stack>
          <Stack gap={1}>
            <Stack direction="row" alignItems="center" gap={1}>
              <BadgeOutlinedIcon fontSize="small" />
              <label>{identificationLabel}: <strong>{user.identification}</strong></label>
            </Stack>
            <Stack direction="row" alignItems="center" gap={1}>
              <PersonOutlineOutlinedIcon fontSize="small" />
              <label>{t('Fullname')}: <strong>{fullName}</strong></label>
            </Stack>
            <Stack direction="row" alignItems="center" gap={1}>
              <BadgeOutlinedIcon fontSize="small" />
              <label>{t('reason')}: <strong>{rejectReason.reason}</strong></label>
            </Stack>
            {
              (user.solutions || rejectReason.solutions) &&
              <Stack direction="row" alignItems="center" gap={1}>
                <BadgeOutlinedIcon fontSize="small" />
                <label>{t('Solution')}: <strong>{user.solutions || rejectReason.solutions}</strong></label>
              </Stack>
            }
            <Stack gap={1}>
              <label>{t('Comments')}:</label>
              <textarea
                className="blacklist-comments"
                value={user.details || ""}
                rows={4}
                readOnly
              />
            </Stack>
          </Stack>
          <Button onClick={onClose} fullWidth size='large' variant='contained'>
            {t('Agreed')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}


const mapStateToProps = state => {
  return {
    custom_visit_identification_label: state.profile.custom_visit_identification_label,
  }
}

export default connect(mapStateToProps)(BlackListDialog)
